import { render, staticRenderFns } from "./RectifierOrderDetailModal.vue?vue&type=template&id=169a0caa&scoped=true"
import script from "./RectifierOrderDetailModal.vue?vue&type=script&lang=js"
export * from "./RectifierOrderDetailModal.vue?vue&type=script&lang=js"
import style0 from "./RectifierOrderDetailModal.vue?vue&type=style&index=0&id=169a0caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169a0caa",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fcomponents%2Forder%2Frectifier-order-detail-modal%2FRectifierOrderDetailModal.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports